import apiClient from './api';

export interface BasicStatsOverview {
    total_conversations: number;
    conversation_trend: string;
    ai_resolve_rate: number;
    resolve_trend: string;
    avg_response_time: number;
    response_trend: string;
    failed_tasks: number;
}

export interface IntentDistributionItem {
    name: string;
    value: number;
    color: string;
}

export interface RecentConversationItem {
    id: string;
    user_name: string;
    intent: string;
    message: string;
    time: string;
    avatar_color: string;
}

export interface BasicStatsResponse {
    overview: BasicStatsOverview;
    intent_distribution: IntentDistributionItem[];
    recent_conversations: RecentConversationItem[];
}

export interface AnalyticsStatsResponse {
    stats: {
        knowledge_docs: number;
        knowledge_trend: string;
        faq_count: number;
        faq_trend: string;
        today_users: number;
        users_trend: string;
        today_conversations: number;
        conversations_trend: string;
    };
    conversation_trend_7d: { date: string; count: number }[];
    knowledge_status: {
        indexed: number;
        processing: number;
        failed: number;
    };
}

export const dashboardApi = {
    getBasicStats: async (): Promise<BasicStatsResponse> => {
        const res = await apiClient.get<BasicStatsResponse>('/admin/dashboard/stats');
        return res.data;
    },
    getAnalytics: async (): Promise<AnalyticsStatsResponse> => {
        const res = await apiClient.get<AnalyticsStatsResponse>('/admin/dashboard/analytics');
        return res.data;
    },
};
